module.exports = __webpack_public_path__ + "static/media/03.19ee090f.jpg";